<div class="d-block">
  <ul class="nav nav-secondary mixed-loyalty-nav" role="gamesnav" aria-label="games nav">
    <a
      class="nav-item reward-nav-item"
      [routerLink]="['/games']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav.games.screenreader' | translate: { fgbdefault: 'Move to Games page' } }}"
    >
      <label>{{ 'games.nav.featured' | translate }}</label>
    </a>

    <a
      class="nav-item reward-nav-item"
      [routerLink]="['/games/jokes']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav.jokes.screenreader' | translate: { fgbdefault: 'Move to Jokes page' } }}"
    >
      <label>{{ 'games.nav.jokes' | translate }}</label>
    </a>
  </ul>
</div>
